export const API_CONFIG = {
  // Toggle this to true to use real backend endpoints
  // When false, the application uses mock data (for testing/development)
  isRealData: true,

  // Base URL for the API
  baseUrl: (import.meta.env.VITE_API_BASE_URL || 'http://72.61.92.71:8000').replace(/\/$/, ''),
};
